/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* These rules are disabled because these eslint rules are deprecated and broken,
even if you have a form control properly linked with forHTML it shows an error */
import PropTypes from 'prop-types';
import { useState, useEffect, createRef } from 'react';
import {
	getSettings,
	watchSettings,
	unwatchSettings,
	setSetting
} from '../utils/eventViewerSettings';

export default function SelectSetting({
	setting,
	options = ['-- No Options Available --'],
	children = ''
}) {
	const selectInput = createRef();
	const [selected, setSelected] = useState(getSettings[setting]);
	useEffect(() => {
		const onSettingsChange = (settings) => {
			setSelected(settings[setting]);
		};
		watchSettings(onSettingsChange);
		return function cleanup() {
			unwatchSettings(onSettingsChange);
		};
	});

	const onChange = () => {
		if (selectInput.current) setSetting(setting, selectInput.current.value);
	};
	return (
		<div className="form-check">
			<label className="form-check-label d-block">
				{children}
				<select
					ref={selectInput}
					className="form-control d-inline-block mx-4"
					style={{
						width: 'fit-content'
					}}
					onChange={onChange}
				>
					{options.map((option) => {
						const attrs = {};
						if (option === selected) attrs.selected = true;
						return (
							<option key={option} {...attrs}>
								{option}
							</option>
						);
					})}
				</select>
			</label>
		</div>
	);
}
SelectSetting.propTypes = {
	setting: PropTypes.string.isRequired,
	children: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.element)
	]),
	options: PropTypes.arrayOf(PropTypes.string)
};
